import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { PolotnoStoreActivePageKeys, useSetPolotnoActivePageState } from '@/pages/AdvancedEditor/hooks';
import { Tooltip } from 'polotno/canvas/tooltip';
import { useEffect } from 'react';
import { DeleteContextualMenu } from '../components/elements/elementOptionsList/contextualMenu/DeleteContextualMenu';
import { OptionsContextualMenu } from '../components/elements/elementOptionsList/contextualMenu/OptionsContextualMenu';
import { UnlockContextualMenu } from '../components/elements/elementOptionsList/contextualMenu/UnlockContextualMenu';
import { ArrangeOptionsList } from '../components/elements/elementOptionsList/options/arrange/ArrangeOptionsList';

const ContextualMenu = () => (
    <>
        <UnlockContextualMenu />
        <ArrangeOptionsList />
        <DeleteContextualMenu />
        <OptionsContextualMenu />
    </>
);

export const useGetWorkspaceComponents = () => {
    const { store } = useAdvancedEditorContext();
    const setIsThereAnySelectedLockedElement = useSetPolotnoActivePageState(PolotnoStoreActivePageKeys.isThereAnySelectedLockedElement);

    useEffect(() => {
        const isThereAnySelectedLockedElement = store.selectedElements.some(element => element.locked);
        setIsThereAnySelectedLockedElement(isThereAnySelectedLockedElement);
    }, [store.selectedElements, store.history.undoIdx]);

    return {
        Tooltip,
        Group: () => null,
        Duplicate: () => null,
        Remove: () => null,
        // Overriding common position, to be contextual menu components
        Position: ContextualMenu,
        TextAiWrite: () => null,
    };
};
